__turbopack_context__.v({
  "blink": "intro-module-scss-module__LhizCq__blink",
  "blinking": "intro-module-scss-module__LhizCq__blinking",
  "description": "intro-module-scss-module__LhizCq__description",
  "intro": "intro-module-scss-module__LhizCq__intro",
  "introContainer": "intro-module-scss-module__LhizCq__introContainer",
  "introContent": "intro-module-scss-module__LhizCq__introContent",
  "introDescription": "intro-module-scss-module__LhizCq__introDescription",
  "introTitle": "intro-module-scss-module__LhizCq__introTitle",
  "title": "intro-module-scss-module__LhizCq__title",
  "typingCursor": "intro-module-scss-module__LhizCq__typingCursor",
  "videoSection": "intro-module-scss-module__LhizCq__videoSection",
  "videoWrp": "intro-module-scss-module__LhizCq__videoWrp",
  "wavesImage": "intro-module-scss-module__LhizCq__wavesImage",
  "wavesWrp": "intro-module-scss-module__LhizCq__wavesWrp",
});
